(function () {
  var core = window.DPPThemeProduct || {}
  var bundleCore = window.DPPThemeProductBundles || {}
  var formatMoney = core.formatMoney
  var normalizeToCents = core.normalizeToCents
  var escapeHtml = core.escapeHtml
  var getThemeConfig = core.getThemeConfig
  var getThemeTranslations = core.getThemeTranslations
  var getCartUrl = core.getCartUrl
  var getShopifyFeatures = core.getShopifyFeatures
  var replaceTokens = core.replaceTokens
  var syncButtonState = core.syncButtonState
  var setBodyScrollLock = core.setBodyScrollLock
  var trapFocusWithin = core.trapFocusWithin

  var fetchBundleVariantDetails = bundleCore.fetchBundleVariantDetails
  var renderBundleComponentMarkup = bundleCore.renderBundleComponentMarkup
  var getBundleOptionLabel = bundleCore.getBundleOptionLabel
  var buildVariantDisplayTitle = bundleCore.buildVariantDisplayTitle
  function setupProductListBundleConfigurator(root, section, payload, payloadSteps) {
    var sourceSelect = section.querySelector('[data-variant-select]')
    var sourceCurrent = root.querySelector('[data-bundle-source-current]')
    var sourceButtons = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-source-option]'))
    var promptPanel = root.querySelector('[data-bundle-configurator-prompt]')
    var promptPreview = root.querySelector('[data-bundle-prompt-preview]')
    var configuratorPanel = root.querySelector('[data-bundle-configurator-panel]')
    var sourceStepRoot = root.querySelector('[data-bundle-configurator-source-step]')
    var wizardNav = root.querySelector('[data-bundle-wizard-nav]')
    var summaryTitle = root.querySelector('[data-bundle-summary-title]')
    var summaryHelper = root.querySelector('[data-bundle-summary-helper]')
    var componentsRoot = root.querySelector('[data-bundle-configurator-components]')
    var priceRoot = root.querySelector('[data-bundle-configurator-price]')
    var feedback = root.querySelector('[data-bundle-configurator-feedback]')
    var submitButton = root.querySelector('[data-bundle-submit]')
    var purchaseForm = sourceSelect ? sourceSelect.closest('form') : section.querySelector('form[action*="/cart/add"]')
    var discountRate = parseFloat(payload.discountPercentage || root.getAttribute('data-bundle-discount-rate') || '0') || 0
    var configuratorId = payload.configuratorId || ''
    var baseProductId = payload.baseProductId || ''
    var discountLabel = root.getAttribute('data-bundle-discount-label') || ''
    var discountRowLabel = root.getAttribute('data-bundle-discount-row-label') || discountLabel
    var volumeSavingsLabel = root.getAttribute('data-bundle-volume-savings-label') || ''
    var subtotalLabel = root.getAttribute('data-bundle-subtotal-label') || ''
    var totalSavingsLabel = root.getAttribute('data-bundle-total-savings-label') || ''
    var totalLabel = root.getAttribute('data-bundle-total-label') || ''
    var mappingNote = root.getAttribute('data-bundle-mapping-note') || ''
    var noMatchLabel = root.getAttribute('data-bundle-no-match-label') || ''
    var priceLabel = root.getAttribute('data-bundle-price-label') || ''
    var compareLabel = root.getAttribute('data-bundle-compare-label') || ''
    var savingsLabel = root.getAttribute('data-bundle-savings-label') || ''
    var summaryItemsLabel = root.getAttribute('data-bundle-summary-items-label') || ''
    var quantityTemplate = root.getAttribute('data-bundle-component-quantity') || '__QUANTITY__x'
    var fixedLabel = root.getAttribute('data-bundle-fixed-label') || ''
    var skipLabel = root.getAttribute('data-bundle-skip-label') || 'Niet toevoegen'
    var skipHelper = root.getAttribute('data-bundle-skip-helper') || ''
    var stepLabelTemplate = root.getAttribute('data-bundle-step-label') || 'Step __NUMBER__'
    var sourceItemLabel = root.getAttribute('data-bundle-source-item-label') || fixedLabel || ''
    var pendingLabel = root.getAttribute('data-bundle-pending-label') || ''
    var productTranslations = getThemeTranslations().product || {}
    var popup = root.querySelector('[data-bundle-popup]')
    var popupSource = popup ? popup.querySelector('[data-bundle-popup-source]') : null
    var popupItems = popup ? popup.querySelector('[data-bundle-popup-items]') : null
    var popupPrice = popup ? popup.querySelector('[data-bundle-popup-price]') : null
    var popupSavingsBadge = popup ? popup.querySelector('[data-bundle-popup-savings-badge]') : null
    var popupCopy = popup ? popup.querySelector('[data-bundle-popup-copy]') : null
    var popupFeedback = popup ? popup.querySelector('[data-bundle-popup-feedback]') : null
    var popupCurrentLabel = root.getAttribute('data-bundle-popup-current-label') || ''
    var popupBundlePriceLabel = root.getAttribute('data-bundle-popup-bundle-price-label') || ''
    var popupShipping = popup ? popup.querySelector('[data-bundle-popup-shipping]') : null
    var popupShippingLabel = popup ? popup.querySelector('[data-bundle-popup-shipping-label]') : null
    var popupAddedNote = popup ? popup.querySelector('[data-bundle-popup-added-note]') : null
    var promptAddButton = root.querySelector('[data-bundle-prompt-add]')
    var promptFeedback = root.querySelector('[data-bundle-prompt-feedback]')
    var promptShipping = root.querySelector('[data-bundle-prompt-shipping]')
    var buyBoxLink = section.querySelector('[data-bundle-buybox-link]')
    var freeShippingThreshold = parseInt(root.getAttribute('data-free-shipping-threshold') || '0', 10) || 0
    var freeShippingLabel = root.getAttribute('data-bundle-free-shipping-label') || ''
    var freeShippingDefaultLabel = root.getAttribute('data-bundle-free-shipping-default-label') || ''
    var popupExtraLabel = root.getAttribute('data-bundle-popup-extra-label') || ''
    var popupTotalLabel = root.getAttribute('data-bundle-popup-total-label') || ''
    var savingsAllLabel = root.getAttribute('data-bundle-savings-all-label') || savingsLabel
    var popularLabel = root.getAttribute('data-bundle-popular-label') || ''
    var bestValueLabel = root.getAttribute('data-bundle-best-value-label') || ''
    var isProductCardHost = !!root.closest('[data-product-card-bundle-host]')
    var pendingSourceLineKey = ''
    var pendingSourceLineQuantity = 0
    var popupCart = null
    var popupPreviouslyFocused = null

    // Bundle funnel events for Shopify customer events (custom pixel) and, when present, the dataLayer.
    function trackBundleEvent(name, detail) {
      var data = Object.assign({
        context: isProductCardHost ? 'plp' : 'pdp',
        configurator_id: String(configuratorId || ''),
        product_id: String(baseProductId || ''),
        variant_id: getSourceVariantId()
      }, detail || {})
      try {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish(name, data)
        }
      } catch (_error) {}
      try {
        if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: name }, data))
      } catch (_error) {}
    }

    function getFormQuantity() {
      var quantityInput = purchaseForm ? purchaseForm.querySelector('[name="quantity"]') : null
      return Math.max(parseInt(quantityInput && quantityInput.value ? quantityInput.value : '1', 10) || 1, 1)
    }

    function formatCents(amountCents) {
      return formatMoney(amountCents, window.Shopify && window.Shopify.money_format)
    }

    // Totals for one bundle: the source variant plus the given step products, before and after the bundle discount.
    function getBundleTotals(stepProducts) {
      var sourcePrice = getSourcePriceCents()
      var subtotal = sourcePrice + (stepProducts || []).reduce(function (sum, product) {
        return sum + normalizeToCents(product.priceCents)
      }, 0)
      var discountedTotal = discountRate > 0 && discountRate < 100 ? Math.round(subtotal * (1 - discountRate / 100)) : subtotal
      return {
        sourcePrice: sourcePrice,
        subtotal: subtotal,
        discountedTotal: discountedTotal,
        bundleDiscount: subtotal > discountedTotal ? subtotal - discountedTotal : 0
      }
    }

    function getShippingMessage(bundleTotal, cart) {
      if (!freeShippingThreshold || !freeShippingLabel) return ''
      if (cart && typeof cart.total_price === 'number' && cart.total_price >= freeShippingThreshold) return ''
      return bundleTotal >= freeShippingThreshold ? freeShippingLabel : ''
    }
    function formatSavingsBadgeLabel(amountCents) {
      var amount = formatMoney(amountCents, window.Shopify && window.Shopify.money_format)
      return savingsLabel ? replaceTokens(savingsLabel, { AMOUNT: amount }) : amount
    }

    function syncPopupSavingsBadge(amountCents) {
      if (!popupSavingsBadge) return
      if (amountCents > 0) {
        popupSavingsBadge.textContent = formatSavingsBadgeLabel(amountCents)
        popupSavingsBadge.classList.remove('hidden')
        popupSavingsBadge.classList.add('inline-flex')
      } else {
        popupSavingsBadge.textContent = ''
        popupSavingsBadge.classList.add('hidden')
        popupSavingsBadge.classList.remove('inline-flex')
      }
    }

    var stepRootsByType = {
      primary: {
        optionsRoot: root.querySelector('[data-bundle-configurator-primary-options]'),
        stepRoot: root.querySelector('[data-bundle-configurator-primary-step]')
      },
      secondary: {
        optionsRoot: root.querySelector('[data-bundle-configurator-secondary-options]'),
        stepRoot: root.querySelector('[data-bundle-configurator-secondary-step]')
      },
      tertiary: {
        optionsRoot: root.querySelector('[data-bundle-configurator-tertiary-options]'),
        stepRoot: root.querySelector('[data-bundle-configurator-tertiary-step]')
      },
      quaternary: {
        optionsRoot: root.querySelector('[data-bundle-configurator-quaternary-options]'),
        stepRoot: root.querySelector('[data-bundle-configurator-quaternary-step]')
      }
    }
    var activeSteps = payloadSteps.map(function (step, index) {
      var roots = stepRootsByType[step.type] || {}
      var configuredLabel = roots.optionsRoot ? roots.optionsRoot.getAttribute('data-bundle-step-select-label') : ''
      var normalizedLabel = step.title || step.label || configuredLabel || ''
      return {
        type: step.type,
        number: index + 1,
        title: normalizedLabel,
        label: normalizedLabel,
        source: step.source || 'products',
        products: Array.isArray(step.products) ? step.products.filter(function (product) {
          return product && product.variantId
        }) : [],
        optional: getExplicitStepOptionalState(step),
        optionsRoot: roots.optionsRoot,
        stepRoot: roots.stepRoot
      }
    }).filter(function (step) {
      return step.products.length > 0 && step.optionsRoot && step.stepRoot
    })
    var selectionState = {}
    var manualSelectionTypes = {}
    var activeWizardIndex = 0

    activeSteps.forEach(function (step, index) {
      if (step.optional === null) step.optional = index > 0 && index === activeSteps.length - 1
    })

    // A step whose options are all one product in different packs is a quantity step: its default
    // follows the position of the chosen variant (variant 2 takes option 2). A step offering
    // different products always defaults to its first option.
    activeSteps.forEach(function (step) {
      var productKeys = step.products.map(function (product) {
        return String(product.productId || product.title || '')
      })
      step.scalesWithSource = step.products.length > 1 && productKeys.every(function (key) {
        return key && key === productKeys[0]
      })
    })

    activeSteps.forEach(function (step) {
      if (step.source !== 'products') return
      var firstVariantIdsByProductId = {}
      step.products.forEach(function (product) {
        var productId = String(product.productId || product.title || '')
        if (!productId || firstVariantIdsByProductId[productId]) return
        firstVariantIdsByProductId[productId] = String(product.variantId || '')
      })
      step.products.forEach(function (product) {
        var productId = String(product.productId || product.title || '')
        if (productId && !product.firstVariantId) product.firstVariantId = firstVariantIdsByProductId[productId] || ''
      })
    })

    Object.keys(stepRootsByType).forEach(function (type) {
      var rootPair = stepRootsByType[type]
      var isActive = activeSteps.some(function (step) { return step.type === type })
      if (rootPair.stepRoot) rootPair.stepRoot.classList.toggle('hidden', !isActive)
      if (!isActive && rootPair.optionsRoot) rootPair.optionsRoot.innerHTML = ''
    })

    if (activeSteps.length === 0) {
      root.classList.add('hidden')
      if (buyBoxLink) buyBoxLink.classList.add('hidden')
      return
    }

    function getExplicitStepOptionalState(step) {
      if (step && step.optional === true) return true
      if (step && step.optional === false) return false
      if (step && step.required === true) return false
      if (step && step.required === false) return true
      return null
    }

    function getSourceOption() {
      return sourceSelect && sourceSelect.selectedIndex >= 0 ? sourceSelect.options[sourceSelect.selectedIndex] : null
    }

    function getSourceButton() {
      var sourceVariantId = getSourceVariantId()
      return sourceButtons.find(function (button) {
        return String(button.getAttribute('data-source-variant-id') || '') === sourceVariantId
      }) || null
    }

    function getSourceValue(attributeName, sourceAttributeName) {
      var sourceOption = getSourceOption()
      if (sourceOption) return sourceOption.getAttribute(attributeName)
      var sourceButton = getSourceButton()
      return sourceButton ? sourceButton.getAttribute(sourceAttributeName || attributeName) : ''
    }

    function getSourceTitle() {
      var sourceOption = getSourceOption()
      if (sourceOption) return (sourceOption.getAttribute('data-title') || sourceOption.textContent || '').trim()
      var sourceButton = getSourceButton()
      return sourceButton ? (sourceButton.getAttribute('data-source-title') || '').trim() : ''
    }

    function getSourceVariantId() {
      if (sourceSelect) return String(sourceSelect.value || '')
      var idInput = purchaseForm ? purchaseForm.querySelector('[name="id"]') : null
      return String((idInput && idInput.value) || root.getAttribute('data-current-variant-id') || '')
    }

    function getSourcePriceCents() {
      return normalizeToCents(getSourceValue('data-price', 'data-source-price'))
    }

    function getSourceCompareAtPriceCents() {
      return normalizeToCents(getSourceValue('data-compare-price', 'data-source-compare-price'))
    }

    function getOptionUnitPrice(option) {
      if (!option) return 0

      var unitPrice = parseInt(option.getAttribute('data-unit-price') || '0', 10)
      return unitPrice > 0 ? unitPrice : 0
    }

    function getOptionUnitQuantity(option) {
      if (!option) return 0

      var title = option.getAttribute('data-title') || option.textContent || ''
      var packCount = core.parsePackCount ? core.parsePackCount(title) : null
      if (packCount && packCount > 0) return packCount

      var liters = core.parseVariantVolumeLiters ? core.parseVariantVolumeLiters(title) : null
      if (liters && liters > 0) return liters

      var quantity = parseFloat(option.getAttribute('data-unit-quantity-value') || '0')
      return !isNaN(quantity) && quantity > 0 ? quantity : 0
    }

    function getOptionUnitReferenceQuantity(option) {
      if (!option) return 0

      var quantity = parseFloat(option.getAttribute('data-unit-reference-value') || '0')
      return !isNaN(quantity) && quantity > 0 ? quantity : 0
    }

    function getUnitScale(unit) {
      var normalizedUnit = String(unit || '').toLowerCase()
      if (normalizedUnit === 'ml') return 1
      if (normalizedUnit === 'cl') return 10
      if (normalizedUnit === 'l' || normalizedUnit === 'liter' || normalizedUnit === 'liters' || normalizedUnit === 'ltr') return 1000
      return 1
    }

    function getOptionMeasuredQuantity(option) {
      if (!option) return 0

      var quantity = parseFloat(option.getAttribute('data-unit-quantity-value') || '0')
      if (isNaN(quantity) || quantity <= 0) return 0

      var referenceQuantity = getOptionUnitReferenceQuantity(option)
      if (referenceQuantity <= 0) return quantity

      var quantityUnit = option.getAttribute('data-unit-quantity-unit') || ''
      var referenceUnit = option.getAttribute('data-unit-reference-unit') || quantityUnit

      return (quantity * getUnitScale(quantityUnit)) / (referenceQuantity * getUnitScale(referenceUnit))
    }

    function getOptionComparableQuantity(option) {
      if (!option) return 0

      var measuredQuantity = getOptionMeasuredQuantity(option)
      if (measuredQuantity > 0) return measuredQuantity

      var title = option.getAttribute('data-title') || option.textContent || ''
      var liters = core.parseVariantVolumeLiters ? core.parseVariantVolumeLiters(title) : null
      if (liters && liters > 0) return liters

      var packCount = core.parsePackCount ? core.parsePackCount(title) : null
      if (packCount && packCount > 0) return packCount

      return 1
    }

    function getOptionRegularUnitPriceCents(option) {
      if (!option) return 0

      var price = normalizeToCents(option.getAttribute('data-price'))
      var quantity = getOptionComparableQuantity(option)
      if (price <= 0 || quantity <= 0) return 0

      var unitPrice = getOptionUnitPrice(option)
      if (getOptionMeasuredQuantity(option) > 0 && unitPrice > 0) return unitPrice

      return price / quantity
    }

    function getSourceUnitRegularPriceCents() {
      var sourceOption = getSourceOption()
      if (!sourceOption || !sourceSelect) return 0

      var sourceQuantity = getOptionComparableQuantity(sourceOption)
      if (sourceQuantity <= 0) return 0

      var options = Array.prototype.slice.call(sourceSelect.options)
      var baseOption = options.reduce(function (currentBase, option) {
        var quantity = getOptionComparableQuantity(option)
        if (quantity <= 0) return currentBase
        if (!currentBase || quantity < getOptionComparableQuantity(currentBase)) return option
        return currentBase
      }, null)
      var baseUnitPrice = getOptionRegularUnitPriceCents(baseOption)

      return baseUnitPrice > 0 ? Math.round(baseUnitPrice * sourceQuantity) : 0
    }

    function getSourceRegularPriceCents() {
      var sourcePrice = getSourcePriceCents()
      var sourceCompareAt = getSourceCompareAtPriceCents()
      var sourceUnitRegularPrice = getSourceUnitRegularPriceCents()

      return Math.max(sourcePrice, sourceCompareAt, sourceUnitRegularPrice)
    }

    function getUnitSuffix() {
      var localeCode = (getThemeConfig().localeCode || '').toLowerCase()
      return localeCode.indexOf('nl') === 0 ? '/stuk' : ' each'
    }

    function getVolumeLiters(variantTitle, productTitle) {
      if (!core.parseVariantVolumeLiters) return 0

      var liters = core.parseVariantVolumeLiters(variantTitle || '')
      if (liters && liters > 0) return liters

      var productLiters = core.parseVariantVolumeLiters(productTitle || '')
      if (!productLiters || productLiters <= 0) return 0

      var packCount = core.parsePackCount ? core.parsePackCount(variantTitle || '') : null
      return (packCount && packCount > 0 ? packCount : 1) * productLiters
    }

    // One unit per set of options: per liter when every option has a known
    // volume, per piece when none has, and no unit label when it is mixed.
    function getUnitMode(entries) {
      var withVolume = entries.filter(function (entry) {
        return getVolumeLiters(entry.variantTitle, entry.productTitle) > 0
      }).length
      if (withVolume === 0) return 'piece'
      return withVolume === entries.length ? 'liter' : 'none'
    }

    function getUnitPriceLabel(price, quantity, liters, unitMode) {
      if (unitMode === 'none') return ''
      if (unitMode === 'liter') return price && liters > 0 ? formatMoney(Math.round(price / liters), window.Shopify && window.Shopify.money_format) + '/L' : ''
      if (!price || !quantity || quantity <= 1) return ''
      return formatMoney(Math.round(price / quantity), window.Shopify && window.Shopify.money_format) + getUnitSuffix()
    }

    function getProductQuantity(product) {
      var title = (product && (product.variantTitle || product.title)) || ''
      var liters = core.parseVariantVolumeLiters ? core.parseVariantVolumeLiters(title) : null
      if (liters && liters > 0) return liters
      var packCount = core.parsePackCount ? core.parsePackCount(title) : null
      return packCount && packCount > 0 ? packCount : 1
    }

    function getStepBaseUnitPrice(step) {
      var baseProduct = step.products.reduce(function (currentBase, product) {
        var quantity = getProductQuantity(product)
        if (quantity <= 0) return currentBase
        if (!currentBase || quantity < getProductQuantity(currentBase)) return product
        return currentBase
      }, null)
      var basePrice = baseProduct ? normalizeToCents(baseProduct.priceCents) : 0
      var baseQuantity = getProductQuantity(baseProduct)

      return basePrice > 0 && baseQuantity > 0 ? basePrice / baseQuantity : 0
    }

    function getProductUnitRegularPrice(product, step) {
      var quantity = getProductQuantity(product)
      var baseUnitPrice = getStepBaseUnitPrice(step)
      return baseUnitPrice > 0 && quantity > 1 ? Math.round(baseUnitPrice * quantity) : normalizeToCents(product.priceCents)
    }

    function getSourceAvailable() {
      var sourceOption = getSourceOption()
      if (sourceOption) return sourceOption.getAttribute('data-available') === 'true'
      var sourceButton = getSourceButton()
      return sourceButton ? !sourceButton.disabled : true
    }

    function getProductDisplayTitle(product) {
      return buildVariantDisplayTitle(product.title, product.variantTitle, product.variantId, product.firstVariantId)
    }

    function getSelectedProduct(step) {
      var selectedVariantId = String(selectionState[step.type] || '')
      if (step.optional && selectedVariantId === '__none__') return null
      if (!selectedVariantId) return null
      return step.products.find(function (product) {
        return String(product.variantId) === selectedVariantId
      }) || null
    }

    function getStepLabel(number) {
      return replaceTokens(stepLabelTemplate, { NUMBER: String(number) })
    }

    function getWizardItems() {
      return [{
        index: 0,
        number: 1,
        title: fixedLabel || sourceItemLabel || getStepLabel(1)
      }].concat(activeSteps.map(function (step, index) {
        return {
          index: index + 1,
          number: index + 2,
          title: step.title || step.label || getStepLabel(index + 2)
        }
      }))
    }

    function setFeedback(message) {
      if (!feedback) return
      feedback.textContent = message || ''
      feedback.classList.toggle('hidden', !message)
    }

    function openConfiguratorPanel(from) {
      trackBundleEvent('dpp_bundle_configurator_opened', { from: from || 'prompt' })
      if (promptPanel) promptPanel.classList.add('hidden')
      if (configuratorPanel) configuratorPanel.classList.remove('hidden')
      root.setAttribute('data-bundle-configurator-opened', 'true')
      renderWizard()
    }

    function closeConfiguratorPanel() {
      if (configuratorPanel) configuratorPanel.classList.add('hidden')
      if (promptPanel) promptPanel.classList.remove('hidden')
      root.removeAttribute('data-bundle-configurator-opened')
      var openButton = root.querySelector('[data-bundle-configurator-open]')
      if (openButton && typeof openButton.focus === 'function') openButton.focus()
    }

    function syncSourceUi() {
      var sourceOption = getSourceOption()
      var title = sourceOption ? (sourceOption.getAttribute('data-title') || sourceOption.textContent || '').trim() : ''
      if (sourceCurrent) sourceCurrent.textContent = title || fixedLabel || ''
      var titleBadgeEl = section.querySelector('[data-variant-title-badge]')
      if (titleBadgeEl && title) {
        titleBadgeEl.textContent = replaceTokens(productTranslations.variantPrefix || '', { TITLE: title })
      }
      var sourceBaseTitle = summaryTitle ? summaryTitle.getAttribute('data-base-title') : ''
      var sourceUnitMode = getUnitMode((sourceSelect ? Array.prototype.slice.call(sourceSelect.options) : []).map(function (option) {
        return { variantTitle: option.getAttribute('data-title') || '', productTitle: sourceBaseTitle }
      }))
      sourceButtons.forEach(function (button) {
        var isActive = String(button.getAttribute('data-source-variant-id') || '') === getSourceVariantId()
        var sourceOptionForButton = sourceSelect ? Array.prototype.slice.call(sourceSelect.options).find(function (option) {
          return String(option.value || '') === String(button.getAttribute('data-source-variant-id') || '')
        }) : null
        var price = normalizeToCents(button.getAttribute('data-source-price'))
        var quantity = getOptionUnitQuantity(sourceOptionForButton)
        var regularPrice = 0
        var badgeEl = button.querySelector('[data-bundle-source-option-discount]')
        var unitEl = button.querySelector('[data-bundle-source-option-unit]')
        if (sourceOptionForButton && sourceSelect) {
          var previousValue = sourceSelect.value
          sourceSelect.value = sourceOptionForButton.value
          regularPrice = getSourceRegularPriceCents()
          sourceSelect.value = previousValue
        }
        var savingAmount = regularPrice > price ? regularPrice - price : 0
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false')
        button.classList.toggle('border-dpp-teal', isActive)
        button.classList.toggle('bg-dpp-tealSoft/70', isActive)
        button.classList.toggle('text-dpp-focus', isActive)
        if (badgeEl) {
          badgeEl.textContent = savingAmount > 0 ? '-' + formatMoney(savingAmount, window.Shopify && window.Shopify.money_format) : ''
          badgeEl.classList.toggle('hidden', savingAmount <= 0)
        }
        if (unitEl) {
          var sourceLiters = sourceOptionForButton
            ? getVolumeLiters(sourceOptionForButton.getAttribute('data-title') || '', sourceBaseTitle)
            : 0
          unitEl.textContent = getUnitPriceLabel(price, quantity, sourceLiters, sourceUnitMode)
          unitEl.classList.toggle('hidden', !unitEl.textContent)
        }
      })
    }

    function renderStepOptions(step) {
      var selectedProduct = getSelectedProduct(step)
      var stepUnitModes = step.products.reduce(function (mapping, product) {
        var key = String(product.productId || product.title || '')
        if (!(key in mapping)) {
          mapping[key] = getUnitMode(step.products.filter(function (candidate) {
            return String(candidate.productId || candidate.title || '') === key
          }).map(function (candidate) {
            return { variantTitle: candidate.variantTitle, productTitle: candidate.title }
          }))
        }
        return mapping
      }, {})

      var optionMarkup = step.products.map(function (product, index) {
        var isSelected = String(product.variantId) === String(selectionState[step.type])
        var price = normalizeToCents(product.priceCents)
        var isExactVariant = product.exactVariant === true || step.source === 'variants'
        var packCount = isExactVariant ? null : core.parsePackCount && core.parsePackCount(product.variantTitle || product.title || '')
        var quantity = getProductQuantity(product)
        var regularPrice = getProductUnitRegularPrice(product, step)
        var savingAmount = regularPrice > price ? regularPrice - price : 0
        var unitPriceLabel = getUnitPriceLabel(price, quantity, getVolumeLiters(product.variantTitle, product.title), stepUnitModes[String(product.productId || product.title || '')])
        var displayTitle = !isExactVariant && step.type === 'primary' && packCount
          ? (String(packCount) + '-pack')
          : getProductDisplayTitle(product)
        var badge = savingAmount > 0
          ? '-' + formatMoney(savingAmount, window.Shopify && window.Shopify.money_format)
          : (!isExactVariant && index === 1
              ? popularLabel
              : (!isExactVariant && index === step.products.length - 1 && step.products.length > 2 ? bestValueLabel : ''))
        return '' +
          '<button class="grid min-h-[92px] grid-cols-[72px_minmax(0,1fr)] gap-3 rounded-dppsm border bg-white p-3 text-left transition hover:border-dpp-teal disabled:cursor-not-allowed disabled:opacity-55 ' + (isSelected ? 'border-dpp-teal bg-dpp-tealSoft/70' : 'border-dpp-border') + '" type="button" data-bundle-product-option data-option-type="' + escapeHtml(step.type) + '" data-variant-id="' + escapeHtml(product.variantId) + '"' + (product.available ? '' : ' disabled') + '>' +
          '<span class="overflow-hidden rounded-dppsm bg-dpp-surfaceSoft">' +
          (product.imageUrl
            ? '<img class="h-[72px] w-[72px] object-contain bg-white p-2" src="' + escapeHtml(product.imageUrl) + '" alt="' + escapeHtml(product.imageAlt || product.title) + '" loading="lazy">'
            : '<span class="block h-[72px] w-[72px] bg-dpp-surfaceSoft"></span>') +
          '</span>' +
          '<span class="grid min-w-0 gap-1">' +
          (badge ? '<span class="w-fit rounded-full bg-dpp-orange px-2 py-1 text-[11px] font-extrabold leading-none text-white">' + escapeHtml(badge) + '</span>' : '') +
          '<span class="text-sm font-bold leading-snug text-dpp-text">' + escapeHtml(displayTitle) + '</span>' +
          '<span class="flex flex-wrap items-center gap-2 text-sm font-semibold text-dpp-price">' +
          escapeHtml(formatMoney(price, window.Shopify && window.Shopify.money_format)) +
          '</span>' +
          (unitPriceLabel ? '<span class="text-xs font-semibold text-dpp-muted">' + escapeHtml(unitPriceLabel) + '</span>' : '') +
          '<span class="text-xs font-semibold text-dpp-muted">' + escapeHtml(product.available ? (step.label || step.title) : (productTranslations.soldOut || 'Uitverkocht')) + '</span>' +
          '</span>' +
          '</button>'
      }).join('')

      if (step.optional) {
        var isSkipped = selectionState[step.type] === '__none__'
        optionMarkup += '' +
          '<button class="grid min-h-[72px] grid-cols-[72px_minmax(0,1fr)] gap-3 rounded-dppsm border bg-white p-3 text-left transition hover:border-dpp-teal ' + (isSkipped ? 'border-dpp-teal bg-dpp-tealSoft/70' : 'border-dpp-border') + '" type="button" data-bundle-product-option data-option-type="' + escapeHtml(step.type) + '" data-variant-id="__none__">' +
          '<span class="flex h-[72px] w-[72px] items-center justify-center rounded-dppsm bg-dpp-tealSoft text-dpp-focus">' +
          '<span class="text-2xl font-extrabold leading-none">-</span>' +
          '</span>' +
          '<span class="grid min-w-0 content-center gap-1">' +
          '<span class="text-sm font-bold leading-snug text-dpp-text">' + escapeHtml(skipLabel) + '</span>' +
          (skipHelper ? '<span class="text-xs font-semibold text-dpp-muted">' + escapeHtml(skipHelper) + '</span>' : '') +
          '</span>' +
          '</button>'
      }

      step.optionsRoot.innerHTML = optionMarkup
    }

    function syncStepChrome() {
      activeSteps.forEach(function (step, index) {
        var label = getStepLabel(index + 2)
        var labelEl = step.stepRoot ? step.stepRoot.querySelector('[data-bundle-step-kicker]') : null
        var numberEl = step.stepRoot ? step.stepRoot.querySelector('[data-bundle-step-number]') : null
        if (labelEl) labelEl.textContent = label
        if (numberEl) numberEl.textContent = String(index + 2)
      })
    }

    function syncStepVisibility() {
      if (sourceStepRoot) sourceStepRoot.classList.toggle('hidden', activeWizardIndex !== 0)
      activeSteps.forEach(function (step, index) {
        if (step.stepRoot) step.stepRoot.classList.toggle('hidden', activeWizardIndex !== index + 1)
      })
    }

    function renderWizard() {
      var wizardItems = getWizardItems()
      if (activeWizardIndex > wizardItems.length - 1) activeWizardIndex = wizardItems.length - 1
      if (activeWizardIndex < 0) activeWizardIndex = 0
      syncStepChrome()
      syncStepVisibility()
      if (!wizardNav) return
      wizardNav.innerHTML = wizardItems.map(function (item) {
        var isActive = item.index === activeWizardIndex
        var isDone = item.index < activeWizardIndex
        return '' +
          '<button class="grid min-h-[64px] grid-cols-[40px_minmax(0,1fr)] items-center gap-3 rounded-dppsm border-0 p-3 text-left transition focus:outline-none focus-visible:ring-2 focus-visible:ring-white/60 md:border ' + (isActive ? 'md:border-white bg-white text-dpp-focus shadow-card' : 'md:border-white/10 bg-white/15 text-white hover:bg-white/25') + '" type="button" data-bundle-wizard-step data-step-index="' + escapeHtml(item.index) + '" aria-current="' + (isActive ? 'step' : 'false') + '">' +
          '<span class="inline-flex h-10 w-10 items-center justify-center rounded-full ' + (isActive || isDone ? 'bg-dpp-teal text-white' : 'border border-white/40 bg-white/10 text-white') + '">' +
          (isDone
            ? '<svg class="h-4 w-4" aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m20 6-11 11-5-5"></path></svg>'
            : '<span class="text-sm font-extrabold">' + escapeHtml(item.number) + '</span>') +
          '</span>' +
          '<span class="grid min-w-0 gap-1">' +
          '<span class="text-[11px] font-extrabold uppercase tracking-[0.16em] ' + (isActive ? 'text-dpp-focus/80' : 'text-white/70') + '">' + escapeHtml(getStepLabel(item.number)) + '</span>' +
          '<span class="truncate text-sm font-extrabold leading-tight">' + escapeHtml(item.title) + '</span>' +
          '</span>' +
          '</button>'
      }).join('')
    }

    function renderSummary() {
      var selectedStepProducts = activeSteps.map(function (step) {
        return {
          step: step,
          product: getSelectedProduct(step)
        }
      }).filter(function (entry) {
        return !!entry.product
      })
      var selectedProducts = selectedStepProducts.map(function (entry) {
        return entry.product
      })
      var sourceTitle = getSourceTitle()
      var baseTitle = summaryTitle ? (summaryTitle.getAttribute('data-base-title') || '') : ''
      var sourceItemTitle = sourceTitle ? (baseTitle + ' - ' + sourceTitle) : baseTitle
      var sourcePrice = getSourcePriceCents()
      var sourceRegularPrice = getSourceRegularPriceCents()
      var stepsPrice = selectedProducts.reduce(function (sum, product) {
        return sum + normalizeToCents(product.priceCents)
      }, 0)
      var stepsRegularPrice = selectedProducts.reduce(function (sum, product) {
        var stepEntry = selectedStepProducts.find(function (entry) {
          return entry.product === product
        })
        return sum + getProductUnitRegularPrice(product, stepEntry ? stepEntry.step : { products: selectedProducts })
      }, 0)
      var subtotal = sourcePrice + stepsPrice
      var regularSubtotal = sourceRegularPrice + stepsRegularPrice
      var discountedTotal = discountRate > 0 && discountRate < 100 ? Math.round(subtotal * (1 - discountRate / 100)) : subtotal
      var bundleDiscount = subtotal > discountedTotal ? subtotal - discountedTotal : 0
      var volumeSavings = regularSubtotal > subtotal ? regularSubtotal - subtotal : 0
      var savings = bundleDiscount + volumeSavings

      if (summaryTitle) summaryTitle.textContent = sourceItemTitle
      if (summaryHelper) summaryHelper.textContent = ''
      if (componentsRoot) {
        var summaryRows = [{
          title: sourceItemTitle,
          quantity: 1
        }].concat(selectedStepProducts.map(function (entry) {
          return {
            title: getProductDisplayTitle(entry.product),
            quantity: 1
          }
        }))
        componentsRoot.innerHTML = '<p class="text-[11px] font-extrabold uppercase tracking-[0.18em] text-dpp-muted">' + escapeHtml(summaryItemsLabel) + '</p>' +
          '<div class="grid gap-2">' + summaryRows.map(function (item) {
            var quantityLabel = replaceTokens(quantityTemplate, { QUANTITY: String(item.quantity || 1) })
            return '' +
              '<div class="flex items-start gap-3 text-sm leading-snug">' +
              '<span class="inline-flex min-h-7 min-w-9 items-center justify-center rounded-full bg-dpp-tealSoft px-2 text-xs font-extrabold text-dpp-focus">' + escapeHtml(quantityLabel) + '</span>' +
              '<span class="min-w-0 pt-1 font-semibold text-dpp-text">' + escapeHtml(item.title || '') + '</span>' +
              '</div>'
          }).join('') +
          (selectedStepProducts.length === 0
            ? '<p class="text-sm font-semibold leading-snug text-dpp-muted">' + escapeHtml(pendingLabel || mappingNote) + '</p>'
            : '') +
          '</div>'
      }
      if (priceRoot) {
        priceRoot.innerHTML = '' +
          '<div class="grid gap-2 text-sm">' +
          '<div class="grid grid-cols-[minmax(0,1fr)_auto] items-center gap-3 text-dpp-muted">' +
          '<span>' + escapeHtml(subtotalLabel || compareLabel) + '</span>' +
          '<span>' + escapeHtml(formatMoney(subtotal, window.Shopify && window.Shopify.money_format)) + '</span>' +
          '</div>' +
          (bundleDiscount > 0
            ? '<div class="grid grid-cols-[minmax(0,1fr)_auto] items-center gap-3 font-semibold text-dpp-focus"><span>' + escapeHtml(discountRowLabel) + '</span><span>-' + escapeHtml(formatMoney(bundleDiscount, window.Shopify && window.Shopify.money_format)) + '</span></div>'
            : '') +
          (volumeSavings > 0
            ? '<div class="grid grid-cols-[minmax(0,1fr)_auto] items-center gap-3 font-semibold text-dpp-focus"><span>' + escapeHtml(volumeSavingsLabel) + '</span><span>-' + escapeHtml(formatMoney(volumeSavings, window.Shopify && window.Shopify.money_format)) + '</span></div>'
            : '') +
          '<div class="mt-1 border-t border-dpp-border pt-3">' +
          '<div class="grid grid-cols-[minmax(0,1fr)_auto] items-end gap-3">' +
          '<span class="text-base font-extrabold leading-tight text-dpp-text">' + escapeHtml(totalLabel || priceLabel) + '</span>' +
          '<span class="text-2xl font-extrabold leading-none text-dpp-price">' + escapeHtml(formatMoney(discountedTotal, window.Shopify && window.Shopify.money_format)) + '</span>' +
          '</div>' +
          (savings > 0
            ? '<div class="mt-3 grid grid-cols-[minmax(0,1fr)_auto] items-center gap-3 rounded-dppsm border border-dpp-orange/30 bg-dpp-orangeSoft px-3 py-2 font-extrabold text-dpp-orange"><span>' + escapeHtml(totalSavingsLabel || savingsLabel) + '</span><span>' + escapeHtml(formatMoney(savings, window.Shopify && window.Shopify.money_format)) + '</span></div>'
            : '') +
          '</div>' +
          '</div>'
        priceRoot.classList.remove('hidden')
      }

      if (submitButton) {
        var requiredStepsSelected = activeSteps.every(function (step) {
          return step.optional || !!getSelectedProduct(step)
        })
        var selectedProductsAvailable = selectedProducts.every(function (product) { return product.available })
        var canSubmit = getSourceAvailable() && requiredStepsSelected && selectedProductsAvailable
        if (!requiredStepsSelected) {
          submitButton.disabled = true
          submitButton.setAttribute('aria-disabled', 'true')
          submitButton.textContent = pendingLabel || noMatchLabel || mappingNote
        } else {
          syncButtonState(submitButton, canSubmit)
        }
      }
    }

    function getSourceVariantIndex() {
      if (sourceSelect) return Math.max(sourceSelect.selectedIndex, 0)
      var sourceButton = getSourceButton()
      return sourceButton ? Math.max(sourceButtons.indexOf(sourceButton), 0) : 0
    }

    // Optional steps without stock are left out instead of defaulting to a sold-out product.
    function getDefaultStepProduct(step) {
      if (step.scalesWithSource) {
        var positionProduct = step.products[getSourceVariantIndex()]
        if (positionProduct && positionProduct.available) return positionProduct
      }
      var firstAvailable = step.products.find(function (product) {
        return product.available
      })
      if (firstAvailable) return firstAvailable
      return step.optional ? null : step.products[0]
    }

    function selectDefaultBundleProducts() {
      var selectedVariantIds = []
      activeSteps.forEach(function (step) {
        if (selectionState[step.type]) {
          if (selectionState[step.type] !== '__none__') selectedVariantIds.push(String(selectionState[step.type]))
          return
        }
        var firstAvailable = getDefaultStepProduct(step)
        if (step.optional && (!firstAvailable || selectedVariantIds.indexOf(String(firstAvailable.variantId || '')) !== -1)) {
          selectionState[step.type] = '__none__'
          return
        }
        if (firstAvailable && firstAvailable.variantId) selectionState[step.type] = String(firstAvailable.variantId)
        if (selectionState[step.type] && selectionState[step.type] !== '__none__') selectedVariantIds.push(String(selectionState[step.type]))
      })
    }

    function getSourcePopupItem() {
      var sourceButton = getSourceButton()
      var sourceTitle = getSourceTitle()
      var baseTitle = summaryTitle ? (summaryTitle.getAttribute('data-base-title') || '') : ''
      return {
        title: buildVariantDisplayTitle(baseTitle, sourceTitle, getSourceVariantId(), ''),
        imageUrl: sourceButton ? sourceButton.getAttribute('data-source-image-url') || '' : '',
        imageAlt: sourceButton ? sourceButton.getAttribute('data-source-image-alt') || baseTitle : baseTitle,
        quantity: 1,
        priceCents: getSourcePriceCents(),
        statusLabel: popupCurrentLabel
      }
    }

    function getDefaultPreviewProducts() {
      var selectedVariantIds = []
      return activeSteps.map(function (step) {
        var selectedProduct = getSelectedProduct(step)
        if (selectedProduct) {
          selectedVariantIds.push(String(selectedProduct.variantId || ''))
          return selectedProduct
        }

        var firstAvailable = getDefaultStepProduct(step)
        if (!firstAvailable || !firstAvailable.variantId) return null
        if (step.optional && selectedVariantIds.indexOf(String(firstAvailable.variantId || '')) !== -1) return null

        selectedVariantIds.push(String(firstAvailable.variantId || ''))
        return firstAvailable
      }).filter(Boolean)
    }

    function renderPromptPreviewItem(item, index, total) {
      var title = item && item.title ? item.title : ''
      return '' +
        '<span class="relative inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-dppsm border border-dpp-border bg-white">' +
        (item && item.imageUrl
          ? '<img class="h-10 w-10 object-contain p-0.5" src="' + escapeHtml(item.imageUrl) + '" alt="' + escapeHtml(item.imageAlt || title) + '" loading="lazy">'
          : '<span class="block h-10 w-10 rounded-dppsm bg-dpp-surfaceSoft"></span>') +
        (index < total - 1
          ? '<span class="absolute -right-3 top-1/2 z-10 inline-flex h-5 w-5 -translate-y-1/2 items-center justify-center rounded-full bg-dpp-teal text-sm font-extrabold leading-none text-white shadow-card">+</span>'
          : '') +
        '</span>'
    }

    // A bundle with a required step that has nothing in stock cannot be bought, so it is not offered.
    function isBundlePurchasable() {
      return getSourceAvailable() && activeSteps.every(function (step) {
        return step.optional || step.products.some(function (product) {
          return product.available
        })
      })
    }

    function syncBundleOfferVisibility(purchasable) {
      if (promptPanel && !root.hasAttribute('data-bundle-configurator-opened')) promptPanel.classList.toggle('hidden', !purchasable)
      var buyboxLink = section.querySelector('[data-bundle-buybox-link]')
      if (buyboxLink) buyboxLink.classList.toggle('hidden', !purchasable)
    }

    function renderPromptPreview() {
      if (!promptPreview) return
      syncBundleOfferVisibility(isBundlePurchasable())

      var sourceItem = getSourcePopupItem()
      var previewProducts = getDefaultPreviewProducts()
      var previewItems = [sourceItem].concat(previewProducts.map(function (product) {
        return {
          title: getProductDisplayTitle(product),
          imageUrl: product.imageUrl || '',
          imageAlt: product.imageAlt || product.title || ''
        }
      })).filter(function (item) {
        return item && (item.title || item.imageUrl)
      }).slice(0, 4)

      if (previewItems.length < 2) {
        promptPreview.innerHTML = ''
        promptPreview.classList.add('hidden')
        syncPromptAddButton(false)
        return
      }

      var quantity = getFormQuantity()
      var totals = getBundleTotals(previewProducts)
      var subtotal = totals.subtotal * quantity
      var discountedTotal = totals.discountedTotal * quantity
      var savings = subtotal - discountedTotal

      promptPreview.innerHTML = '' +
        '<div class="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">' +
        '<div class="flex items-center gap-3">' +
        previewItems.map(function (item, index) {
          return renderPromptPreviewItem(item, index, previewItems.length)
        }).join('') +
        '</div>' +
        '<div class="grid text-center md:text-left">' +
        '<span class="flex items-baseline justify-center gap-2 md:justify-start">' +
        (savings > 0 ? '<span class="text-sm font-semibold text-dpp-muted line-through">' + escapeHtml(formatCents(subtotal)) + '</span>' : '') +
        '<span class="text-xl font-extrabold leading-tight text-dpp-price">' + escapeHtml(formatCents(discountedTotal)) + '</span>' +
        '</span>' +
        (savings > 0 ? '<span class="text-sm font-extrabold text-dpp-orange">' + escapeHtml(replaceTokens(savingsAllLabel, { AMOUNT: formatCents(savings) })) + '</span>' : '') +
        '</div>' +
        '</div>'
      promptPreview.classList.remove('hidden')

      if (promptShipping) {
        promptShipping.textContent = getShippingMessage(discountedTotal, null) || freeShippingDefaultLabel || promptShipping.textContent
      }
      syncPromptAddButton(true)
    }

    function syncPromptAddButton(hasPreview) {
      if (!promptAddButton) return
      promptAddButton.classList.toggle('hidden', !hasPreview)
      promptAddButton.classList.toggle('inline-flex', !!hasPreview)
      var canAdd = hasPreview && getSourceAvailable() && getDefaultPreviewProducts().every(function (product) {
        return product.available
      })
      promptAddButton.disabled = !canAdd
      promptAddButton.setAttribute('aria-disabled', canAdd ? 'false' : 'true')
    }

    function setPromptFeedback(message) {
      if (!promptFeedback) return
      promptFeedback.textContent = message || ''
      promptFeedback.classList.toggle('hidden', !message)
    }

    function renderPopupItem(item) {
      var title = item && item.title ? item.title : ''
      var quantityLabel = replaceTokens(quantityTemplate, { QUANTITY: String((item && item.quantity) || 1) })
      return '' +
        '<div class="grid grid-cols-[48px_minmax(0,1fr)] gap-2 rounded-dppsm bg-white/70 p-2 md:grid-cols-[56px_minmax(0,1fr)_auto] md:items-center">' +
        '<span class="overflow-hidden rounded-dppsm bg-white">' +
        (item && item.imageUrl
          ? '<img class="h-12 w-12 object-contain bg-white p-1 md:h-14 md:w-14" src="' + escapeHtml(item.imageUrl) + '" alt="' + escapeHtml(item.imageAlt || title) + '" loading="lazy">'
          : '<span class="block h-12 w-12 bg-white md:h-14 md:w-14"></span>') +
        '</span>' +
        '<span class="grid min-w-0 content-center gap-1">' +
        '<span class="text-sm font-extrabold leading-snug text-dpp-text">' + escapeHtml(quantityLabel) + ' - ' + escapeHtml(title) + '</span>' +
        '</span>' +
        renderBundleLinePrice(item, false) +
        '</div>'
    }

    function renderBundleLinePrice(item, showBundleDiscount) {
      var quantity = (item && item.quantity) || 1
      var unitPrice = item && item.priceCents ? normalizeToCents(item.priceCents) : 0
      var compareAtPrice = item && item.compareAtPriceCents ? normalizeToCents(item.compareAtPriceCents) : 0
      var originalLinePrice = Math.max(compareAtPrice, unitPrice) * quantity

      if (originalLinePrice <= 0) return ''

      var discountedLinePrice = unitPrice * quantity
      if (showBundleDiscount !== false && discountRate > 0 && discountRate < 100) {
        discountedLinePrice = Math.round(originalLinePrice * (1 - (discountRate / 100)))
      }

      return '' +
        '<span class="flex flex-wrap items-baseline gap-x-2 gap-y-1 text-sm md:justify-end md:pl-2">' +
        (discountedLinePrice < originalLinePrice
          ? '<span class="font-semibold text-dpp-muted line-through">' + escapeHtml(formatMoney(originalLinePrice, window.Shopify && window.Shopify.money_format)) + '</span>'
          : '') +
        '<span class="font-extrabold text-dpp-price">' + escapeHtml(formatMoney(discountedLinePrice, window.Shopify && window.Shopify.money_format)) + '</span>' +
        '</span>'
    }

    function renderBundleBlockRow(item) {
      var title = item && item.title ? item.title : ''
      var quantityLabel = replaceTokens(quantityTemplate, { QUANTITY: String((item && item.quantity) || 1) })
      var statusLabel = item && item.statusLabel ? item.statusLabel : ''
      return '' +
        '<div class="grid grid-cols-[48px_minmax(0,1fr)] gap-2 py-1.5 md:grid-cols-[52px_minmax(0,1fr)_auto] md:items-center">' +
        '<span class="overflow-hidden rounded-dppsm bg-white">' +
        (item && item.imageUrl
          ? '<img class="h-12 w-12 object-contain bg-white p-1 md:h-[52px] md:w-[52px]" src="' + escapeHtml(item.imageUrl) + '" alt="' + escapeHtml(item.imageAlt || title) + '" loading="lazy">'
          : '<span class="block h-12 w-12 bg-white md:h-[52px] md:w-[52px]"></span>') +
        '</span>' +
        '<span class="grid min-w-0 content-center gap-1">' +
        (statusLabel ? '<span class="w-fit rounded-full bg-white px-2 py-1 text-[11px] font-extrabold uppercase tracking-[0.12em] text-dpp-focus">' + escapeHtml(statusLabel) + '</span>' : '') +
        '<span class="text-sm font-extrabold leading-snug text-dpp-text">' + escapeHtml(quantityLabel) + ' - ' + escapeHtml(title) + '</span>' +
        '</span>' +
        renderBundleLinePrice(item) +
        '</div>'
    }

    function renderPopupBundleBlock(sourceItem, addedItems) {
      return '' +
        '<div class="grid gap-1.5 rounded-dppmd border border-dpp-teal/30 bg-dpp-tealSoft/40 px-3 py-2">' +
        renderBundleBlockRow(sourceItem) +
        (addedItems.length > 0
          ? '<div class="flex items-center gap-2 text-dpp-focus" aria-hidden="true"><span class="h-px flex-1 bg-dpp-teal/30"></span><span class="inline-flex h-6 w-6 items-center justify-center rounded-full bg-white text-sm font-extrabold leading-none">+</span><span class="h-px flex-1 bg-dpp-teal/30"></span></div>' +
            '<div class="grid gap-1 divide-y divide-dpp-teal/30">' + addedItems.map(renderBundleBlockRow).join('') + '</div>'
          : '') +
        '</div>'
    }

    // The source product is already in the cart at full price, so the popup leads with what the
    // shopper pays extra for the rest of the bundle and keeps the full bundle total as context.
    function renderPopupPrice(quantity) {
      if (!popupPrice) return
      var selectedProducts = activeSteps.map(function (step) {
        return getSelectedProduct(step)
      }).filter(Boolean)
      var totals = getBundleTotals(selectedProducts)
      var subtotal = totals.subtotal * quantity
      var discountedTotal = totals.discountedTotal * quantity
      var bundleDiscount = totals.bundleDiscount * quantity
      var extra = discountedTotal - (totals.sourcePrice * quantity)
      syncPopupSavingsBadge(bundleDiscount)
      popupPrice.innerHTML = '' +
        '<div class="grid gap-1 rounded-dppmd border border-dpp-teal/30 bg-dpp-tealSoft/70 p-3 text-sm shadow-card">' +
        (extra > 0 && popupExtraLabel
          ? '<div class="flex flex-wrap items-end justify-between gap-2">' +
            '<span class="text-base font-extrabold text-dpp-text">' + escapeHtml(popupExtraLabel) + '</span>' +
            '<span class="text-2xl font-extrabold leading-none text-dpp-price">+ ' + escapeHtml(formatCents(extra)) + '</span>' +
            '</div>' +
            '<div class="flex flex-wrap items-baseline justify-between gap-2 text-dpp-muted">' +
            '<span>' + escapeHtml(popupTotalLabel || popupBundlePriceLabel || totalLabel) + '</span>' +
            '<span class="flex flex-wrap items-baseline justify-end gap-2">' +
            (bundleDiscount > 0 ? '<span class="line-through">' + escapeHtml(formatCents(subtotal)) + '</span>' : '') +
            '<span class="font-bold text-dpp-text">' + escapeHtml(formatCents(discountedTotal)) + '</span>' +
            '</span>' +
            '</div>'
          : '<div class="flex flex-wrap items-end justify-between gap-2">' +
            '<span class="text-base font-extrabold text-dpp-text">' + escapeHtml(popupBundlePriceLabel || totalLabel || priceLabel) + '</span>' +
            '<span class="flex flex-wrap items-baseline justify-end gap-2">' +
            (bundleDiscount > 0 ? '<span class="text-sm font-semibold text-dpp-muted line-through">' + escapeHtml(formatCents(subtotal)) + '</span>' : '') +
            '<span class="text-2xl font-extrabold leading-none text-dpp-price">' + escapeHtml(formatCents(discountedTotal)) + '</span>' +
            '</span>' +
            '</div>') +
        '</div>'
      popupPrice.classList.remove('hidden')

      var shippingMessage = getShippingMessage(discountedTotal, popupCart)
      if (popupShipping && popupShippingLabel) {
        popupShippingLabel.textContent = shippingMessage
        popupShipping.classList.toggle('hidden', !shippingMessage)
        popupShipping.classList.toggle('flex', !!shippingMessage)
      }
    }

    function setPopupFeedback(message) {
      if (!popupFeedback) return
      popupFeedback.textContent = message || ''
      popupFeedback.classList.toggle('hidden', !message)
    }

    // options.lineQuantity: the cart line's total quantity after the add, so accepting the bundle
    // only takes back what was just added. options.cart: the refreshed cart, for the shipping hint.
    // options.fromCart: opened from the cart reminder, so the product was not just added.
    function openBundlePopup(sourceLineKey, options) {
      if (!popup || !isBundlePurchasable()) return false
      var popupOptions = options || {}
      selectDefaultBundleProducts()
      render()
      pendingSourceLineKey = sourceLineKey || ''
      pendingSourceLineQuantity = parseInt(popupOptions.lineQuantity || '0', 10) || 0
      popupCart = popupOptions.cart || null
      var quantity = getFormQuantity()
      var selectedItems = activeSteps.map(function (step) {
        var product = getSelectedProduct(step)
        return product ? {
          title: getProductDisplayTitle(product),
          imageUrl: product.imageUrl || '',
          imageAlt: product.imageAlt || product.title || '',
          quantity: quantity,
          priceCents: product.priceCents
        } : null
      }).filter(Boolean)
      var sourceItem = getSourcePopupItem()
      sourceItem.quantity = quantity
      if (popupSource) popupSource.innerHTML = renderPopupItem(sourceItem)
      if (popupItems) popupItems.innerHTML = renderPopupBundleBlock(sourceItem, selectedItems)
      if (popupCopy && popup.getAttribute('data-bundle-popup-text')) popupCopy.textContent = popup.getAttribute('data-bundle-popup-text')
      if (popupAddedNote) popupAddedNote.classList.toggle('hidden', !!popupOptions.fromCart)
      renderPopupPrice(quantity)
      setPopupFeedback('')
      trackBundleEvent('dpp_bundle_popup_shown', { source: popupOptions.fromCart ? 'cart_reminder' : 'add_to_cart', step_count: selectedItems.length })
      popupPreviouslyFocused = document.activeElement
      popup.classList.remove('hidden')
      popup.classList.add('flex')
      popup.setAttribute('aria-hidden', 'false')
      if (setBodyScrollLock) setBodyScrollLock('bundle-popup', true)
      window.setTimeout(function () {
        var focusTarget = popup.querySelector('[data-bundle-popup-submit]:not([disabled])') || popup.querySelector('[data-bundle-popup-keep]') || popup.querySelector('[data-bundle-popup-close]')
        if (focusTarget && typeof focusTarget.focus === 'function') focusTarget.focus()
      }, 0)
      return true
    }

    root.DPPBundleConfigurator = Object.assign(root.DPPBundleConfigurator || {}, {
      openBundlePopup: openBundlePopup
    })

    function closeBundlePopup() {
      if (!popup) return
      popup.classList.add('hidden')
      popup.classList.remove('flex')
      popup.setAttribute('aria-hidden', 'true')
      if (setBodyScrollLock) setBodyScrollLock('bundle-popup', false)
      if (popupPreviouslyFocused && typeof popupPreviouslyFocused.focus === 'function') popupPreviouslyFocused.focus()
    }

    function showRegularProductCartResult() {
      closeBundlePopup()
      window.setTimeout(function () {
        window.location.href = getCartUrl ? getCartUrl() : '/cart'
      }, 0)
    }

    function getCartAddLineQuantity(payload) {
      if (!payload) return 0
      if (payload.quantity) return payload.quantity
      if (Array.isArray(payload.items) && payload.items[0] && payload.items[0].quantity) return payload.items[0].quantity
      return 0
    }

    function getCartAddLineKey(payload) {
      if (!payload) return ''
      if (payload.key) return payload.key
      if (Array.isArray(payload.items) && payload.items[0] && payload.items[0].key) return payload.items[0].key
      return ''
    }

    function addRegularProductForPopup(submitButton) {
      if (!purchaseForm) return false
      if (submitButton) submitButton.disabled = true
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(purchaseForm)
      })
        .then(function (response) {
          if (!response.ok) throw new Error('add_failed')
          return response.json()
        })
        .then(function (payload) {
          var refreshCart = window.DPPThemeCart && window.DPPThemeCart.refresh
          var openPopup = function (cart) {
            openBundlePopup(getCartAddLineKey(payload), {
              lineQuantity: getCartAddLineQuantity(payload),
              cart: cart && cart.items ? cart : null
            })
          }

          return refreshCart ? refreshCart('bundle-popup-product-add').then(openPopup).catch(function () { openPopup(null) }) : openPopup(null)
        })
        .catch(function () {
          window.location.href = getCartUrl ? getCartUrl() : '/cart'
        })
        .finally(function () {
          if (submitButton) submitButton.disabled = false
        })
      return true
    }

    function render() {
      root.classList.remove('hidden')
      syncSourceUi()
      activeSteps.forEach(renderStepOptions)
      renderSummary()
      renderWizard()
      renderPromptPreview()
      setFeedback('')
    }

    function bundleLineProperties(groupId, step, stepCount, extraProperties) {
      var properties = {
        _bundle_configurator_id: String(configuratorId || ''),
        _bundle_base_product_id: String(baseProductId || ''),
        _bundle_discount_percentage: String(discountRate || 0),
        _bundle_group_id: groupId,
        _bundle_step: String(step),
        _bundle_step_count: String(stepCount),
        _dpp_bundle_group: groupId,
        _dpp_bundle_source: 'product_list_configurator',
        _dpp_bundle_discount: String(discountRate || 0),
        _dpp_bundle_role: String(step),
        _dpp_bundle_step_count: String(stepCount)
      }
      Object.keys(extraProperties || {}).forEach(function (key) {
        if (extraProperties[key] !== undefined && extraProperties[key] !== null && extraProperties[key] !== '') properties[key] = extraProperties[key]
      })
      return properties
    }

    function addBundle(submitter, sourceLineKey, from) {
      if (!purchaseForm) return false
      var quantity = getFormQuantity()
      var sourceVariantId = getSourceVariantId()
      var stepSelections = activeSteps.map(function (step, index) {
        var selectedProduct = getSelectedProduct(step)
        return {
          step: step,
          stepNumber: index + 1,
          product: selectedProduct,
          skipped: !selectedProduct
        }
      })
      var selectedProducts = stepSelections.filter(function (selection) {
        return !!selection.product
      })
      var firstMissingRequiredStepIndex = activeSteps.findIndex(function (step) {
        return !step.optional && !getSelectedProduct(step)
      })
      var fullStepCount = activeSteps.length
      var selectedStepCount = selectedProducts.length
      var groupId = 'bundle-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8)
      var items = []

      if (!sourceVariantId) {
        setFeedback(noMatchLabel || mappingNote)
        return true
      }

      if (firstMissingRequiredStepIndex >= 0) {
        activeWizardIndex = firstMissingRequiredStepIndex + 1
        render()
        setFeedback(pendingLabel || noMatchLabel || mappingNote)
        return true
      }

      var baseProperties = {
        _dpp_bundle_required_quantity: '1',
        _dpp_bundle_configured_step_count: String(activeSteps.length),
        _dpp_bundle_selected_step_count: String(selectedStepCount)
      }
      stepSelections.forEach(function (selection) {
        var stepKey = '_dpp_bundle_step_' + selection.stepNumber
        baseProperties[stepKey + '_label'] = selection.step.title || selection.step.label || ''
        baseProperties[stepKey + '_variant_id'] = selection.product ? String(selection.product.variantId || '') : ''
        baseProperties[stepKey + '_skipped'] = selection.skipped ? 'true' : 'false'
      })
      items.push({
        id: Number(sourceVariantId),
        quantity: quantity,
        properties: bundleLineProperties(groupId, 'base', fullStepCount, baseProperties)
      })
      selectedProducts.forEach(function (selection) {
        var product = selection.product
        items.push({
          id: Number(product.variantId),
          quantity: quantity,
          properties: bundleLineProperties(groupId, String(selection.stepNumber), fullStepCount, {
            _dpp_bundle_parent_variant_id: sourceVariantId,
            _dpp_bundle_required_quantity: '1',
            _dpp_bundle_step_label: selection.step.title || selection.step.label || ''
          })
        })
      })

      if (submitter) submitter.disabled = true
      setFeedback('')

      // Take back only what was just added: a line that already held this variant keeps its earlier units.
      var remainingSourceQuantity = sourceLineKey && pendingSourceLineQuantity > quantity ? pendingSourceLineQuantity - quantity : 0
      var removeSourceLine = sourceLineKey
        ? fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ id: sourceLineKey, quantity: remainingSourceQuantity })
          }).then(function (response) {
            if (!response.ok) throw new Error('bundle_source_remove_failed')
            return response.json()
          })
        : Promise.resolve()

      removeSourceLine.then(function () {
        return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: items })
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('bundle_add_failed')
          return response.json()
        })
        .then(function () {
          trackBundleEvent('dpp_bundle_added', {
            from: from || 'configurator',
            quantity: quantity,
            selected_step_count: selectedStepCount,
            value: getBundleTotals(selectedProducts.map(function (selection) { return selection.product })).discountedTotal * quantity
          })
          window.location.href = getCartUrl ? getCartUrl() : '/cart'
        })
        .catch(function () {
          var errorLabel = popup ? (popup.getAttribute('data-bundle-popup-error-label') || noMatchLabel || mappingNote) : (noMatchLabel || mappingNote)
          setFeedback(noMatchLabel || mappingNote)
          setPopupFeedback(errorLabel)
          if (from === 'prompt') setPromptFeedback(errorLabel)
          if (submitter) submitter.disabled = false
        })

      return true
    }

    root.addEventListener('click', function (event) {
      var openButton = event.target.closest('[data-bundle-configurator-open]')
      if (openButton) {
        event.preventDefault()
        openConfiguratorPanel('prompt')
        return
      }

      var promptAdd = event.target.closest('[data-bundle-prompt-add]')
      if (promptAdd) {
        event.preventDefault()
        setPromptFeedback('')
        selectDefaultBundleProducts()
        render()
        addBundle(promptAdd, '', 'prompt')
        return
      }

      var closeButton = event.target.closest('[data-bundle-configurator-close]')
      if (closeButton) {
        event.preventDefault()
        closeConfiguratorPanel()
        return
      }

      var productOption = event.target.closest('[data-bundle-product-option]')
      if (productOption) {
        var optionType = productOption.getAttribute('data-option-type') || ''
        selectionState[optionType] = productOption.getAttribute('data-variant-id') || ''
        manualSelectionTypes[optionType] = true
        if (activeWizardIndex < activeSteps.length) activeWizardIndex += 1
        render()
        return
      }

      var bundleSubmitButton = event.target.closest('[data-bundle-submit]')
      if (bundleSubmitButton) {
        event.preventDefault()
        addBundle(bundleSubmitButton, '', 'configurator')
        return
      }

      var sourceContinueButton = event.target.closest('[data-bundle-source-continue]')
      if (sourceContinueButton) {
        event.preventDefault()
        if (activeSteps.length > 0) activeWizardIndex = 1
        render()
        return
      }

      var sourceButton = event.target.closest('[data-bundle-source-option]')
      if (sourceButton) {
        var sourceVariantId = sourceButton.getAttribute('data-source-variant-id') || ''
        if (sourceSelect && sourceVariantId && String(sourceSelect.value) !== sourceVariantId) {
          sourceSelect.value = sourceVariantId
          sourceSelect.dispatchEvent(new Event('change', { bubbles: true }))
        }
        if (activeSteps.length > 0) activeWizardIndex = 1
        render()
        return
      }

      var wizardStepButton = event.target.closest('[data-bundle-wizard-step]')
      if (wizardStepButton) {
        var requestedWizardIndex = parseInt(wizardStepButton.getAttribute('data-step-index') || '0', 10) || 0
        activeWizardIndex = requestedWizardIndex
        renderWizard()
        return
      }
    })

    if (purchaseForm) {
      purchaseForm.addEventListener('submit', function (event) {
        var submitter = event.submitter || document.activeElement
        if (submitter && submitter.closest && submitter.closest('[data-bundle-submit]')) return
        if (!isBundlePurchasable()) return
        event.preventDefault()
        event.stopPropagation()
        addRegularProductForPopup(submitter && submitter.matches && submitter.matches('button[type="submit"]') ? submitter : purchaseForm.querySelector('button[type="submit"]'))
      }, true)
    }

    if (popup) {
      popup.addEventListener('click', function (event) {
        if (event.target.closest('[data-bundle-popup-keep]')) {
          event.preventDefault()
          trackBundleEvent('dpp_bundle_popup_declined', { action: 'cart' })
          showRegularProductCartResult()
          return
        }
        if (event.target.closest('[data-bundle-popup-close], [data-bundle-popup-dismiss]')) {
          event.preventDefault()
          trackBundleEvent('dpp_bundle_popup_declined', { action: 'close' })
          closeBundlePopup()
          return
        }
        if (event.target.closest('[data-bundle-popup-configure]')) {
          event.preventDefault()
          closeBundlePopup()
          openConfiguratorPanel('popup')
          root.scrollIntoView({ behavior: 'smooth', block: 'start' })
          return
        }
        var popupSubmit = event.target.closest('[data-bundle-popup-submit]')
        if (popupSubmit) {
          event.preventDefault()
          addBundle(popupSubmit, pendingSourceLineKey, 'popup')
        }
      })
      document.addEventListener('keydown', function (event) {
        if (popup.getAttribute('aria-hidden') !== 'false') return
        if (event.key === 'Escape') {
          trackBundleEvent('dpp_bundle_popup_declined', { action: 'close' })
          closeBundlePopup()
          return
        }
        if (trapFocusWithin) trapFocusWithin(event, popup)
      })
    }

    if (buyBoxLink && !isProductCardHost) {
      buyBoxLink.addEventListener('click', function (event) {
        if (!event.target.closest('a')) return
        trackBundleEvent('dpp_bundle_buybox_link_click')
      })
    }

    if (purchaseForm && !isProductCardHost) {
      purchaseForm.addEventListener('input', function (event) {
        if (event.target && event.target.matches && event.target.matches('[name="quantity"]')) renderPromptPreview()
      })
    }

    // The cart reminder links here with ?bundle_line=<cart line key>: reopen the bundle popup for
    // that line so accepting the bundle replaces the loose product instead of adding a second one.
    function openPopupFromCartReminder() {
      if (isProductCardHost || !window.URLSearchParams) return
      var params = new URLSearchParams(window.location.search)
      var lineKey = params.get('bundle_line')
      if (!lineKey) return
      params.delete('bundle_line')
      if (window.history && typeof window.history.replaceState === 'function') {
        var query = params.toString()
        window.history.replaceState(window.history.state, '', window.location.pathname + (query ? '?' + query : '') + window.location.hash)
      }
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('cart_fetch_failed')
          return response.json()
        })
        .then(function (cart) {
          var line = (cart.items || []).find(function (item) { return item.key === lineKey })
          if (!line) return
          if (sourceSelect && String(sourceSelect.value) !== String(line.variant_id)) {
            var hasOption = Array.prototype.some.call(sourceSelect.options, function (option) {
              return String(option.value) === String(line.variant_id)
            })
            if (!hasOption) return
            sourceSelect.value = String(line.variant_id)
            sourceSelect.dispatchEvent(new Event('change', { bubbles: true }))
          }
          var quantityInput = purchaseForm ? purchaseForm.querySelector('[name="quantity"]') : null
          if (quantityInput) quantityInput.value = String(line.quantity)
          openBundlePopup(lineKey, { lineQuantity: line.quantity, cart: cart, fromCart: true })
        })
        .catch(function () {})
    }

    // A new variant moves the default of quantity steps the shopper did not pick themselves.
    function resetScaledDefaults() {
      activeSteps.forEach(function (step) {
        if (step.scalesWithSource && !manualSelectionTypes[step.type]) delete selectionState[step.type]
      })
      render()
    }

    if (sourceSelect) sourceSelect.addEventListener('change', resetScaledDefaults)
    render()
    openPopupFromCartReminder()
  }

  window.DPPThemeProductBundles = Object.assign(window.DPPThemeProductBundles || {}, {
    setupProductListBundleConfigurator: setupProductListBundleConfigurator
  })
})()
